import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { ReviewAmsDataPage } from '@/components/Ams/review/ReviewAmsDataPage'
import {
  plainReviewAmsSearch,
  pruneReviewAmsSearch,
  reviewAmsSearchSchema,
} from '@/components/Ams/review/search'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only. The schema and its pruning live beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/marketing/review-ams-data/')({
  validateSearch: reviewAmsSearchSchema,
  // VentaHub's plain query string for this route only (AmsViewPage.tsx:614-694).
  search: { middlewares: [plainReviewAmsSearch] },
  component: ReviewAmsDataRoute,
})

function ReviewAmsDataRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <ReviewAmsDataPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(pruneReviewAmsSearch, next, options))
      }
    />
  )
}
